import { render, staticRenderFns } from "./CardChat.vue?vue&type=template&id=0904cb1e&scoped=true&"
import script from "./CardChat.vue?vue&type=script&lang=js&"
export * from "./CardChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0904cb1e",
  null
  
)

export default component.exports